import React, { useState } from "react";
import ShotClassContainer from "../ShotClassContainer/ShotClassContainer";
import classes from "./DistributeSeries.module.scss";
import SeriesHistoryModal from "./SeriesHistory/SeriesHistoryModal";
import SeriesDeleteModal from "./SeriesDelete/SeriesDeleteModal";
import { useNavigate } from "react-router";
import { createSeries } from "../../../utils/mainTabs/distribute/createSeries";

const DistributeSeriesList = ({
  seriesData,
  setDeleteSeriesData,
  deleteModal,
  setDeleteModal,
  handleCheckboxChange,
  tenantName,
}) => {
  const navigate = useNavigate();
  const [programData, setProgramData] = useState(null);
  const [historyModal, setHistoryModal] = useState(false);

  const handleHistroyClick = (id) => {
    setHistoryModal(true);
    setProgramData(id);
  };

  const handleDelete = (data) => {
    setDeleteModal(true);
    setProgramData(data);
  };

  const handleCopyClick = (id) => {
    navigate(`${createSeries.copyPath(tenantName)}/${id}`);
  };

  const imageClick = (id) => {
    navigate(`${createSeries.editPath(tenantName)}/${id}`);
  };

  return (
    <>
      <div className={classes.distributeSeriesList}>
        {seriesData?.length > 0 &&
          seriesData?.map((item) => (
            <div key={item?.Programs?.ID}>
              <ShotClassContainer
                type="series"
                data={item?.Programs}
                isInfoIconVisible
                isCheckboxVisible
                infoText={`${
                  item?.Programs?.PublishedbyMe
                    ? "Published by Me "
                    : "Published by Others "
                }`}
                // isCopyIconVisible
                isHistoryIconVisible
                // isDeleteVisible
                handleHistroyClick={() =>
                  handleHistroyClick(item?.Programs?.ID)
                }
                handleDelete={() => handleDelete(item?.Programs)}
                handleCheckboxChange={handleCheckboxChange}
                isChecked={item?.Programs?.checked}
                handleCopyClick={() => handleCopyClick(item?.Programs?.ID)}
                // imageClick={() => imageClick(item?.Programs?.ID)}
              />
            </div>
          ))}
      </div>
      {historyModal && (
        <SeriesHistoryModal
          historyModal={historyModal}
          setHistoryModal={setHistoryModal}
          programId={programData}
        />
      )}
      {deleteModal && (
        <SeriesDeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          programData={programData}
          setDeleteSeriesData={setDeleteSeriesData}
        />
      )}
    </>
  );
};

export default DistributeSeriesList;
